import styled from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import { Card } from '../AssetCard/styled.es.js';

const AssetCardGroup = styled(Box)`
    width: 100%;
    display: flex;
    flex-direction: column;
    ${Card}:not(:last-child) {
        margin-bottom: ${spacing("xs")};
    }
`;
const Styled = {
  AssetCardGroup
};

export { Styled };
//# sourceMappingURL=styled.es.js.map
